import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "login_wrap login_bg" }
const _hoisted_3 = { class: "login sign_form" }
const _hoisted_4 = { class: "link_wrap" }
const _hoisted_5 = { class: "btn_wrap _default" }
const _hoisted_6 = { class: "sns_wrap" }
const _hoisted_7 = { class: "sns_btn_wrap _default" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[12] || (_cache[12] = _createElementVNode("h3", null, "로그인", -1)),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.state.username) = $event)),
                onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => ($setup.login && $setup.login(...args)), ["enter"])),
                placeholder: "아이디"
              }, null, 544), [
                [_vModelText, $setup.state.username]
              ])
            ]),
            _createElementVNode("li", null, [
              _withDirectives(_createElementVNode("input", {
                type: "password",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.state.password) = $event)),
                onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => ($setup.login && $setup.login(...args)), ["enter"])),
                placeholder: "비밀번호"
              }, null, 544), [
                [_vModelText, $setup.state.password]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              type: "button",
              class: "",
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.openModal(0, false)))
            }, "아이디 찾기"),
            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "deco" }, "｜", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "",
              onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.openModal(1, false)))
            }, "비밀번호 찾기"),
            _createVNode(_component_router_link, {
              to: "/join",
              class: "main_c"
            }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createTextVNode("회원가입", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              type: "button",
              class: "submit_btn",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.login && $setup.login(...args)))
            }, "로그인")
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[11] || (_cache[11] = _createElementVNode("p", null, "SNS 계정으로 간편하게 가입하기", -1)),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                type: "button",
                class: "",
                onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.snsLogin('naver')))
              }, [...(_cache[10] || (_cache[10] = [
                _createElementVNode("img", {
                  src: "img/naver.png",
                  alt: ""
                }, null, -1)
              ]))])
            ])
          ])
        ])
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          isForm: !$setup.state.modalIsResult,
          isResult: $setup.state.modalIsResult,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "isForm", "isResult", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true),
    ($setup.state2.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 1,
          type: $setup.state2.modalTab,
          title: $setup.state2.modalTitle,
          content: $setup.state2.modalContent,
          onClose: $setup.closeModal2,
          onCallback: $setup.callBackModal2
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Footer)
  ], 64))
}